import BaseLogic from "../base_logic"

export default class ReservierungBestaetigtLogic extends BaseLogic {}
